import React, { lazy, useEffect, useState } from "react";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import ForgotPassword from "../pages/ForgotPassword/ForgotPassword";
import Login from "../pages/Login/Login";
import Register from "../pages/Register/Register";
import Otp from "../pages/ResetPassword/Otp";
import NewPassword from "../pages/ResetPassword/NewPassword";
import PrivateRoutes from "./PrivateRoutes";
import TermsConditions from "../pages/TermsConditions/TermsConditions";
import PrivacyPolicy from "../pages/PrivacyPolicy/PrivacyPolicy";
import PageNotFound from "../pages/404/PageNotFound";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import Swal from "sweetalert2";
import { useTranslation } from "react-i18next";
import { fetchAuthUser } from "../redux/slices/UserSlice";
import { useAuth } from "../context/AuthContext";
import TestMap from "../pages/Profile/TestMap";
import RequiredInfoPage from "../pages/RequiredInfoPage";

const Home = lazy(() => import("../pages/Home/Home"));
const AboutUs = lazy(() => import("../pages/AboutUs/AboutUs"));

const Profile = lazy(() => import("../pages/Profile/Profile"));
const BranchProfile = lazy(() => import("../pages/Profile/BranchProfile"));
const ChangePassword = lazy(() =>
  import("../pages/ChangePassword/ChangePassword")
);
//
//DASHBOARD
const Dashboard = lazy(() => import("../pages/Dashboard/Dashboard"));
//
//OFFERS
const Offers = lazy(() => import("../pages/Offers/Offers"));
const AddOffer = lazy(() => import("../pages/Offers/AddOffer"));
const EditOffer = lazy(() => import("../pages/Offers/EditOffer"));
const Comments = lazy(() => import("../pages/Offers/Comments"));
const ViewOffer = lazy(() => import("../pages/Offers/ViewOffer"));
const CustomerSecondTimeOfferPending = lazy(() =>
  import("../pages/Offers/CustomerSecondTimeOfferPending")
);
const OfferRedemptions = lazy(() =>
  import("../pages/Offers/OfferRedemptions")
);
//
//OFFER REDEEM
const OfferRedeem = lazy(() => import("../pages/OfferRedeem/OfferRedeem"));
//
// BRANCH
const Branches = lazy(() => import("../pages/Branches/Branches"));
const AddBranch = lazy(() => import("../pages/Branches/AddBranch"));
const EditBranch = lazy(() => import("../pages/Branches/EditBranch"));
const ViewBranch = lazy(() => import("../pages/Branches/ViewBranch"));
//
//OTHERS
const Subscription = lazy(() => import("../pages/Subscription/Subscription"));

const Chats = lazy(() => import("../pages/Chats/Chats"));
const Message = lazy(() => import("../pages/Chats/Message"));

const Transactions = lazy(() => import("../pages/Reports/Transactions"));
const Analysis = lazy(() => import("../pages/Analysis/Analysis"));
const CustomerInteraction = lazy(() =>
  import("../pages/Reports/CustomerInteraction")
);
const OfferPerformance = lazy(() =>
  import("../pages/Reports/OfferPerformance")
);
const LoyaltyProgram = lazy(() =>
  import("../pages/LoyaltyProgram/LoyaltyProgram")
);

const CustomerRedeem = lazy(() =>
  import("../pages/LoyaltyProgram/CustomerRedeem")
);

const LoyaltyProgramReport = lazy(() =>
  import("../pages/Reports/LoyaltyProgramReport")
);

const PointsCalculation = lazy(() =>
  import("../pages/LoyaltyProgram/PointsCalculation")
);

const ViewOfferWithOutLogin = lazy(() => import("../pages/Offers/OfferDetail"));

const BillingHistory = lazy(() =>
  import("../pages/BillingHistory/BillingHistory")
);

const Notification = lazy(() => import("../pages/Notification/Notification"));

const RequireSubcription = ({ children, hasSubscription, authUser }) => {
  // console.log("hasSubscription", hasSubscription);

  if (hasSubscription) {
    return <Navigate to="/subscription" replace />;
  }

  return children;
};

const AppRoutes = () => {
  const { t } = useTranslation();

  const navigate = useNavigate();

  const token = localStorage.getItem("token");
  const userType = localStorage.getItem("userType");

  const { authUser } = useSelector((state) => state.userStore);

  const [hasSubscription, setHasSubscription] = useState(false);

  let currentDate = moment();

  useEffect(() => {
    if (userType == "2" && authUser) {
      let userSubscriptionExpiryDate = moment(
        authUser?.subscription_expiry_date
      );

      setHasSubscription((prev) =>
        currentDate.isAfter(userSubscriptionExpiryDate, "day")
      );

      let diffInDays = userSubscriptionExpiryDate.diff(currentDate, "days");

      if (diffInDays < 5 && diffInDays >= 0) {
        Swal.fire({
          title:
            diffInDays != 0
              ? t(
                `Your subscription will be expired with in {count} Days`
              ).replace("{count}", diffInDays)
              : t(`Your subscription will be expired Today`),
          text: t("Please Renew or Upgrade your subscription"),
          icon: "info",
          iconColor: "#837fd8",
          confirmButtonColor: "#837fd8",
        });
      }
    } else if (userType == "3" && authUser) {
      let userSubscriptionExpiryDate = moment(
        authUser?.subscription_expiry_date
      );
      setHasSubscription((prev) =>
        currentDate.isAfter(userSubscriptionExpiryDate, "day")
      );
      if (currentDate.isAfter(userSubscriptionExpiryDate, "day")) {
        Swal.fire({
          title: t("Your merchant subscription has expired. Please contact your merchant or log in as a merchant to renew or upgrade the subscription."),
          text: t("Please contact your merchant."),
          icon: "info",
          iconColor: "#837fd8",
          confirmButtonColor: "#837fd8",
        });
        localStorage.removeItem("token");
        localStorage.removeItem("name");
        localStorage.removeItem("userType");
        navigate("/login");
      }
    }
    // if (!authUser) {
    //   setHasSubscription(true);
    // }
  }, [JSON.stringify(authUser)]);

  useEffect(() => {
    if (authUser && authUser?.status != 1) {
      Swal.fire({
        title: t("Your account has been deactivated."),
        text: t("Please contact the administrator."),
        icon: "info",
        iconColor: "#837fd8",
        confirmButtonColor: "#837fd8",
      });

      localStorage.removeItem("token");
      // localStorage.removeItem("email");
      localStorage.removeItem("name");
      localStorage.removeItem("userType");
      navigate("/login");
    }
  }, [JSON.stringify(authUser)]);

  useEffect(() => {
    if (authUser && authUser?.token != token) {
      localStorage.removeItem("token");
      // localStorage.removeItem("email");
      localStorage.removeItem("name");
      localStorage.removeItem("userType");
      navigate("/login");
    }
  }, [JSON.stringify(authUser)]);

  return (
    <>
      <Routes>
        <Route path="*" element={<PageNotFound />} />
        <Route path="unautorized" element={<PageNotFound />} />
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/sign-up" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        {/* <Route path="/reset-password" element={<ResetPassword />} /> */}
        <Route path="/otp" element={<Otp />} />
        <Route path="/reset-password" element={<NewPassword />} />

        {/* <Route path="/about-us" element={<AboutUs />} /> */}

        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/required-info" element={<RequiredInfoPage />} />
        <Route path="/t&c" element={<TermsConditions />} />

        <Route path="/offer-detail/:id" element={<ViewOfferWithOutLogin />} />

        {/* Dashboard */}
        <Route
          path="/dashboard"
          element={
            <PrivateRoutes roles={["2", "3"]}>
              <RequireSubcription hasSubscription={hasSubscription} authUser>
                <Dashboard />
              </RequireSubcription>
            </PrivateRoutes>
          }
        />

        <Route
          path="/offer-redemptions"
          element={
            <PrivateRoutes roles={["2","3"]}>
              <RequireSubcription hasSubscription={hasSubscription}>
                <OfferRedemptions />
              </RequireSubcription>
            </PrivateRoutes>
          }
        />

        <Route
          path="/customer-second-time-offer-pending"
          element={
            <PrivateRoutes roles={["2"]}>
              <RequireSubcription hasSubscription={hasSubscription}>
                <CustomerSecondTimeOfferPending />
              </RequireSubcription>
            </PrivateRoutes>
          }
        />

        {/* Profile */}
        <Route
          path="/profile"
          element={
            <PrivateRoutes roles={["2"]}>
              <RequireSubcription hasSubscription={hasSubscription}>
                <Profile />
              </RequireSubcription>
            </PrivateRoutes>
          }
        />
        <Route
          path="/branch-profile"
          element={
            <PrivateRoutes roles={["3"]}>
              <BranchProfile />
            </PrivateRoutes>
          }
        />

        <Route
          path="/change-password"
          element={
            <PrivateRoutes roles={["2", "3"]}>
              <RequireSubcription hasSubscription={hasSubscription}>
                <ChangePassword />
              </RequireSubcription>
            </PrivateRoutes>
          }
        />

        {/* Offers */}

        <Route
          path="/offers"
          element={
            <PrivateRoutes roles={["2", "3"]}>
              <RequireSubcription hasSubscription={hasSubscription}>
                <Offers />
              </RequireSubcription>
            </PrivateRoutes>
          }
        />

        <Route
          path="/offers-redeem"
          element={
            <PrivateRoutes roles={["3"]}>
              <OfferRedeem />
            </PrivateRoutes>
          }
        />
        <Route
          path="/add-offer"
          element={
            <PrivateRoutes roles={["2"]}>
              <RequireSubcription hasSubscription={hasSubscription}>
                <AddOffer />
              </RequireSubcription>
            </PrivateRoutes>
          }
        />
        <Route
          path="/edit-offer"
          element={
            <PrivateRoutes roles={["2"]}>
              <RequireSubcription hasSubscription={hasSubscription}>
                <EditOffer />
              </RequireSubcription>
            </PrivateRoutes>
          }
        />
        <Route
          path="/comments"
          element={
            <PrivateRoutes roles={["2", "3"]}>
              <RequireSubcription hasSubscription={hasSubscription}>
                <Comments />
              </RequireSubcription>
            </PrivateRoutes>
          }
        />
        <Route
          path="/view-offer"
          element={
            <PrivateRoutes roles={["2", "3"]}>
              <RequireSubcription hasSubscription={hasSubscription}>
                <ViewOffer />
              </RequireSubcription>
            </PrivateRoutes>
          }
        />

        {/* Branchs */}
        <Route
          path="/branches"
          element={
            <PrivateRoutes roles={["2"]}>
              <RequireSubcription hasSubscription={hasSubscription}>
                <Branches />{" "}
              </RequireSubcription>
            </PrivateRoutes>
          }
        />
        <Route
          path="/add-branch"
          element={
            <PrivateRoutes roles={["2"]}>
              <RequireSubcription hasSubscription={hasSubscription}>
                <AddBranch />
              </RequireSubcription>
            </PrivateRoutes>
          }
        />
        <Route
          path="/edit-branch"
          element={
            <PrivateRoutes roles={["2"]}>
              <RequireSubcription hasSubscription={hasSubscription}>
                <EditBranch />
              </RequireSubcription>
            </PrivateRoutes>
          }
        />
        <Route
          path="/view-branch"
          element={
            <PrivateRoutes roles={["2"]}>
              <RequireSubcription hasSubscription={hasSubscription}>
                <ViewBranch />
              </RequireSubcription>
            </PrivateRoutes>
          }
        />

        {/* Others */}
        <Route
          path="/analysis"
          element={
            <PrivateRoutes roles={["2", "3"]}>
              <RequireSubcription hasSubscription={hasSubscription}>
                <Analysis />
              </RequireSubcription>
            </PrivateRoutes>
          }
        />
        <Route
          path="/subscription"
          element={
            <PrivateRoutes roles={["2"]}>
              <Subscription />
            </PrivateRoutes>
          }
        />
        <Route
          path="/billing-history"
          element={
            <PrivateRoutes roles={["2"]}>
              <RequireSubcription hasSubscription={hasSubscription}>
                <BillingHistory />
              </RequireSubcription>
            </PrivateRoutes>
          }
        />

        <Route
          path="/loyalty-program"
          element={
            <PrivateRoutes roles={["2", "3"]}>
              <RequireSubcription hasSubscription={hasSubscription}>
                <LoyaltyProgram />
              </RequireSubcription>
            </PrivateRoutes>
          }
        />

        <Route
          path="/point-calculation"
          element={
            <PrivateRoutes roles={["2", "3"]}>
              <RequireSubcription hasSubscription={hasSubscription}>
                <PointsCalculation />
              </RequireSubcription>
            </PrivateRoutes>
          }
        />

        <Route
          path="/customer-redemption-offers"
          element={
            <PrivateRoutes roles={["2"]}>
              <RequireSubcription hasSubscription={hasSubscription}>
                <CustomerRedeem />
              </RequireSubcription>
            </PrivateRoutes>
          }
        />

        {/* Reports */}
        <Route
          path="/transactions"
          element={
            <PrivateRoutes roles={["2", "3"]}>
              <RequireSubcription hasSubscription={hasSubscription}>
                <Transactions />
              </RequireSubcription>
            </PrivateRoutes>
          }
        />
        <Route
          path="/offer-perfomace-report"
          element={
            <PrivateRoutes roles={["2", "3"]}>
              <RequireSubcription hasSubscription={hasSubscription}>
                <OfferPerformance />
              </RequireSubcription>
            </PrivateRoutes>
          }
        />
        <Route
          path="/customer-interaction-report"
          element={
            <PrivateRoutes roles={["2", "3"]}>
              <RequireSubcription hasSubscription={hasSubscription}>
                <CustomerInteraction />
              </RequireSubcription>
            </PrivateRoutes>
          }
        />
        <Route
          path="/loyalty-program-report"
          element={
            <PrivateRoutes roles={["2", "3"]}>
              <RequireSubcription hasSubscription={hasSubscription}>
                <LoyaltyProgramReport />
              </RequireSubcription>
            </PrivateRoutes>
          }
        />

        <Route
          path="/test-map"
          element={
            <PrivateRoutes roles={["2", "3"]}>
              <RequireSubcription hasSubscription={hasSubscription}>
                <TestMap />
              </RequireSubcription>
            </PrivateRoutes>
          }
        />

        {/* Chats */}
        <Route
          path="/chats"
          element={
            <PrivateRoutes roles={["2", "3"]}>
              <RequireSubcription hasSubscription={hasSubscription}>
                <Chats />
              </RequireSubcription>
            </PrivateRoutes>
          }
        />
        <Route
          path="/message"
          element={
            <PrivateRoutes roles={["2", "3"]}>
              <RequireSubcription hasSubscription={hasSubscription}>
                <Message />
              </RequireSubcription>
            </PrivateRoutes>
          }
        />
        <Route
          path="/notification"
          element={
            <PrivateRoutes roles={["2"]}>
              <RequireSubcription hasSubscription={hasSubscription}>
                <Notification />
              </RequireSubcription>
            </PrivateRoutes>
          }
        />
      </Routes>
    </>
  );
};

export default AppRoutes;
